// extracted by mini-css-extract-plugin
export default {"component":"AsAndSetMenu_component__uJ1qK","menuComponent":"AsAndSetMenu_menuComponent__2PyKF","active":"AsAndSetMenu_active__Uh8kt","passive":"AsAndSetMenu_passive__EtB0j"};